import React from 'react';
import { Link } from 'react-router-dom';

const ActionLink = props => {
    const { result, resultActions, setShowConfirmPopUp, setShowProtestPopUp, setShowSchedulePopUp, matchPostScore, 'data-testid': dataTestId } = props;
    return (
        <>
            {result
                ? (
                    resultActions.accept.allowed
                        ? (
                            <p data-testid={dataTestId && `${dataTestId}.actions-container`}>
                                <Link onClick={() => { setShowConfirmPopUp(true); }} data-testid={dataTestId && `${dataTestId}.confirm-link`}> <i className="utr utr-check-circle" /> Confirm score</Link> |
                                <Link onClick={(e) => { matchPostScore(e); }} data-testid={dataTestId && `${dataTestId}.edit-link`}> <i className="fa fa-pencil-alt" /> Edit score</Link> |
                                <Link onClick={() => { setShowProtestPopUp(true); }} data-testid={dataTestId && `${dataTestId}.protest-link`}> <i className="utr utr-close" /> Protest score</Link>
                            </p>
                        )
                        : (
                            <p data-testid={dataTestId && `${dataTestId}.actions-container`}>
                                <Link onClick={(e) => { matchPostScore(e); }} data-testid={dataTestId && `${dataTestId}.edit-link`}> <i className="fa fa-pencil-alt" /> Edit score</Link>
                            </p>
                        )
                )
                : (
                    <p data-testid={dataTestId && `${dataTestId}.actions-container`}>
                        <Link onClick={() => { setShowSchedulePopUp(true); }} data-testid={dataTestId && `${dataTestId}.schedule-link`}><i className="fas fa-calendar" /> Schedule match</Link> |
                        <Link
onClick={(e) => {
                            matchPostScore(e);
                        }}
                        data-testid={dataTestId && `${dataTestId}.post-scores-link`}
                        > <i className="fas fa-light fa-plus-circle" /> Post scores
                        </Link>
                    </p>
                )}
        </>
    );
};

ActionLink.defaultProps = {
    'data-testid': null,
};

export default ActionLink;
